import React from 'react'
import { motion, useAnimation } from 'framer-motion';

export default function TextSpan({children}) {
    const controls = useAnimation();
    const scale = ()=>{
        controls.start({
            transform: [
                "scale3d(1, 1, 1)",
                "scale3d(1.4, .55, 1)",
                "scale3d(.75, 1.25, 1)",
                "scale3d(1.25, .85, 1)",
                "scale3d(.9, 1.05, 1)",
                "scale3d(1, 1, 1)",
            ],
            transition: {
                times: [0, .3, .6, .7, .8, .9]
            }
        })
    }
  return (
    <motion.span animate={controls} onMouseOver={() => scale()} className='text-4xl sm:text-7xl font-bold text-[#ccd6f6] inline-block'>
        {children}
    </motion.span>
  )
}
